import { useContext } from "react";
import Filters from "./filters";
import Table from "./table";
import { Drawer } from "@MASTER";
import { DrawerContext } from "@CONTEXTS";
import useTabs from "./tab-content";

const Invoice = () => {
  const TabContent = useTabs();
  const drawer = useContext(DrawerContext);

  return (
    <>
      <div className="app-content-header">
        <div style={{ width: "100%", padding: "12px 24px" }}>
          <Filters />
        </div>
      </div>
      <div className="nav-page-content">
        <Table />
        {drawer.visible && <Drawer tabs={TabContent} hideFooter />}
      </div>
    </>
  );
};

export default Invoice;
